import { ResourceIrbLinks } from '../types';

export const IRB_LINKS_MOCK_DATA: ResourceIrbLinks[] = [
  {
    href: 'https://www.wcgclinical.com/solutions/irb-review/',
    name: 'Click here for IRB Website',
  },
  {
    href: 'https://www.wcgclinical.com/irb-resources/',
    name: 'Click here for IRB Resource Center',
  },
];
